import React from "react"
import { Link } from "gatsby"

const Pricing = () => {
  return (
    <>
      <div className="pricing-area bg-f9f9f9 pt-100 pb-70">
        <div className="container">
          <div className="section-title">
            <span className="sub-title">Dịch vụ eKYC</span>
            <h2>Các gói cước chính</h2>
            <p>
            eKYC là một dịch vụ quan trọng được doanh nghiệp ứng dụng để thu hút khách hàng, rút ngắn thời gian xác minh, tiết kiệm chi phí, và tăng cường hiệu quả hoạt động.
            </p>
          </div>

          <div className="row justify-content-center">
            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <div className="single-pricing-box">
                <div className="pricing-header">
                  <div className="icon">
                    <i className="flaticon-paper-plane"></i>
                    <div className="circles-box">
                      <div className="circle-one"></div>
                    </div>
                  </div>
                  <h3>Starter Plan</h3>
                </div>

                <div className="pricing-features">
                  <ul>
                    <li>Chi phí theo giao dịch</li>
                    <li>Đối soát hàng tháng</li>
                    <li>24/7 Support</li>
                  </ul>
                </div>

                <div className="price">
                Cloud
                <span>Tính theo giao dịch</span>
                </div>

                <Link to="#" className="default-btn">
                  Liên hệ
                </Link>
              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="single-pricing-box">
                <div className="pricing-header">
                  <div className="icon">
                    <i className="flaticon-jigsaw"></i>
                    <div className="circles-box">
                      <div className="circle-one"></div>
                    </div>
                  </div>
                  <h3>Advance Plan</h3>
                </div>

                <div className="pricing-features">
                  <ul>
                    <li>Chi phí trọn gói theo tháng</li>
                    <li>Trả phí hàng tháng</li>
                    <li>24/7 Support</li>
                  </ul>
                </div>

                <div className="price">
                Cloud
                <span>Tính theo năm</span>
                </div>

                <Link to="#" className="default-btn">
                Liên hệ
                </Link>
              </div>
            </div>

            <div 
              className="col-lg-4 col-md-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              <div className="single-pricing-box">
                <div className="pricing-header">
                  <div className="icon">
                    <i className="flaticon-diamond"></i>
                    <div className="circles-box">
                      <div className="circle-one"></div>
                    </div>
                  </div>
                  <h3>Premium Plan</h3>
                </div>

                <div className="pricing-features">
                  <ul>
                    <li>Chi phí trọn gói theo năm</li>
                    <li>Trả phí hàng năm</li>
                    <li>24/7 Support</li>
                  </ul>
                </div>

                <div className="price">
                On-premise
                <span>Tính theo năm</span>
                </div>

                <Link to="#" className="default-btn">
                Liên hệ
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Pricing
